// app/javascript/utils/firebase/initialise.js

import { initializeApp, getApps, getApp } from 'firebase/app';

// Ensure the global config object exists before accessing it
if (!window.firebaseConfigs) {
  throw new Error("Firebase configuration not found. Make sure it's injected from Rails into window.firebaseConfigs");
}

// Read configuration injected by Rails
const firebaseConfig = window.firebaseConfigs;

// Initialize Firebase App (prevent re-initialization)
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();

// Export the initialized app instance
export { app };
